import 'prop-types';
import * as React from 'react';

function getAdornment(adornment, props) {
  if (adornment === void 0 || adornment === null || typeof adornment === "boolean") return null;

  if (Array.isArray(adornment)) {
    if (adornment.some(function (e) {
      return ! /*#__PURE__*/React.isValidElement(e);
    })) {
      return null;
    }

    return adornment;
  }

  return typeof adornment === "string" || /*#__PURE__*/React.isValidElement(adornment) ? adornment : /*#__PURE__*/React.createElement(adornment, props);
}

export { getAdornment };
